import { render, staticRenderFns } from "./WarningDetail.vue?vue&type=template&id=2df5fcaa&scoped=true&"
import script from "./WarningDetail.vue?vue&type=script&lang=ts&"
export * from "./WarningDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WarningDetail.vue?vue&type=style&index=0&id=2df5fcaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5fcaa",
  null
  
)

export default component.exports